export function base64Encode(input: string): string {
    const bytes = new TextEncoder().encode(input);
    let binary = "";
    bytes.forEach((b) => {
        binary += String.fromCharCode(b);
    });
    return btoa(binary);
}

export function base64Decode(input: string): string {
    const binary = atob(input);
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    return new TextDecoder().decode(bytes);
}

export function urlEncode(input: string): string {
    return encodeURIComponent(input);
}

export function urlDecode(input: string): string {
    return decodeURIComponent(input);
}
